import React from 'react';
import { Box, Typography } from '@mui/material';
import * as COLOR from '../../../../../constants/colors';
import { AnswerDisplayProps } from '../types';

export const AnswerDisplay: React.FC<AnswerDisplayProps> = ({ answer, question }) => {
  if (typeof answer === "string" || !answer) {
    return (
      <Typography
        sx={{
          fontSize: { xs: 16, md: 18 },
          fontWeight: 400,
          color: COLOR.GREY3,
          lineHeight: 1.4,
          textAlign: "left",
          letterSpacing: "0%",
          width: "100%",
          minWidth: 0,
          wordBreak: "break-word",
        }}
        role="region"
        aria-label={`Answer to: ${question}`}
      >
        {answer ?? ""}
      </Typography>
    );
  }

  return (
    <Box 
      sx={{ fontSize: 16, color: COLOR.GREY3 }}
      role="region"
      aria-label={`Answer to: ${question}`}
    >
      {answer}
    </Box>
  );
};
